<template>
  <div class="precision-drive-scene">
    <!-- 顶部宣传区域 -->
    <div class="top-banner">
      <div class="banner-content">
        <h2 class="title">{{ $t('aboutUs.title') }}</h2>
        <h1 class="main-title">{{ form.title }}</h1>
        <div class="icon-list">
          <div class="icon-item">
            <span>{{ form.content }}</span>
          </div>
        </div>
      </div>
      <div class="banner-image-container">
        <img :src="$VUE_APP_BASE_API + form.background" :alt="$t('loading')" class="banner-image"/>
      </div>
    </div>

    <div class="main-container">
      <!-- 公司介绍区域 -->
      <div class="intro-section">
        <div class="intro-content">
          <div class="introduce">
            <div class="introduce-prompt" style="width: 100%;">{{ $t('aboutUs.companyIntro.prompt') }}</div>
            <div class="introduce-title">{{ $t('aboutUs.companyIntro.title') }}<span style="color: #006BFF ">{{ $t('aboutUs.companyIntro.titleHighlight') }}</span></div>
            <div class="xiahuaxian"></div>
            <div class="introduce-content">{{ form.introductionText }}</div>
          </div>
        </div>
        <div class="intro-image">
          <img :src="$VUE_APP_BASE_API + form.introductionImg" alt="main-image" class="main-image">
        </div>
      </div>

      <!-- 数据统计区域 -->
      <div class="divider"></div>
      <div class="divider-content">
        <div v-for="(item,index) in dividerList" :key="index" class="divider-item">
          <img :src="$VUE_APP_BASE_API + item.dataImg" :alt="$t('loading')" class="divider-icon"/>
          <span class="divider-shuju">{{ item.dataValue }}</span>
          <span class="divider-shuoming divider-shuoming-foot">{{ item.dataTitle }}</span>
        </div>
      </div>
      <div class="divider"></div>

      <!-- 技术介绍区域 -->
      <div class="tech-section">
        <div class="tech-image">
          <img :src="$VUE_APP_BASE_API + form.abilityImg" alt="main-image" class="main-image">

        </div>
        <div class="tech-content">
          <div class="introduce">
            <div class="introduce-prompt">{{ $t('aboutUs.techIntro.prompt') }}</div>
            <div class="introduce-title">{{ $t('aboutUs.techIntro.title') }}<span style="color: #006BFF">{{ $t('aboutUs.techIntro.titleHighlight') }}</span></div>
            <div class="xiahuaxian"></div>
            <div class="introduce-content">{{ form.abilityText}}</div>
          </div>
          <div class="ability-content">
            <div v-for="(item,index) in abilityList" :key="index" class="ability-item">
              <div class="divider-shuju">{{ item.dataValue }}</div>
              <div class="divider-shuoming">{{ item.dataTitle }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 服务领域区域 -->
<!--      <div class="fields-section">-->
<!--        <div class="section-title">-->
<!--          <div class="section-subtitle">{{ $t('aboutUs.serviceFields.subtitle') }}</div>-->
<!--          <div class="introduce-title">{{ $t('aboutUs.serviceFields.title') }}<span style="color: #006BFF ">{{ $t('aboutUs.serviceFields.titleHighlight') }}</span></div>-->
<!--          <div><span class="xiahuaxian" style="display: inline-block;"></span></div>-->
<!--        </div>-->
<!--        <div class="fields-grid">-->
<!--          <div v-for="(item,index) in imgList" :key="index" class="field-item">-->
<!--            <img :src="$VUE_APP_BASE_API + item.dataImg" alt="" class="field-image"/>-->
<!--            <div class="field-name">{{ item.dataTitle }}</div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

      <!-- 服务与维修区域 -->
      <!-- <div class="service-section">
        <div class="section-title">
          <div class="section-subtitle">服务与维修</div>
          <div class="introduce-title">我们的<span style="color: #006BFF ">布局</span></div>
          <div><span class="xiahuaxian" style="display: inline-block;"></span></div>
        </div>
        <div class="map-container">
           <chinaMap ref="chinaMap" :mapData="mapData"/>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
// import chinaMap from "@/components/ECharts/chinaMap/chinaMap.vue";
import {getAboutUsByOne, listSysAboutUs, listSysAboutUsAddress} from "@/api/sysytem/homePage";

export default {
  name: 'aboutUs',
  // components: {chinaMap},
  data() {
    return {
      concept :'我们将以优质的产品，可靠的质量，优越的终生效能费用比和有效的服务，满足旋转加工领域日益增长的主轴需求。',
      dividerList: [],
      abilityList: [],
      imgList: [],
      form:{},
      // mapData:[],
    }
  },
  created() {
    this.getAboutInfo();
    this.getAboutDataList();
    // this.getAboutAddressList()
  },
  methods: {
    getAboutInfo(){
      getAboutUsByOne(this.form).then(res => {
        if(res.data){
          this.form = res.data;
        }
      });
    },
    getAboutDataList(){
      this.loading = true;
      listSysAboutUs({}).then(res => {
        this.dividerList = res.data.filter(item => item.dataFlag === 'intro');
        this.abilityList = res.data.filter(item => item.dataFlag === 'skill');
        this.imgList = res.data.filter(item => item.dataFlag === 'ability');
        this.loading = false;
      });
    },
    // getAboutAddressList(){
    //   listSysAboutUsAddress({}).then(res => {
    //     // this.$refs.chinaMap.initData(res.data)
    //     this.mapData = res.data
    //   });
    // },

  }
}
</script>

<style scoped>
.precision-drive-scene {
  background-color: #000;
  overflow: hidden;
  color: #fff;
}

/* 顶部宣传区域样式 */
.top-banner {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.banner-image-container {
  width: 100%;
  overflow: hidden;
}

.banner-image {
  width: 100%;
  height: 450px;
  display: block;
  object-fit: cover; 
  aspect-ratio: 16/9; 
}

.banner-content {
  max-width: 500px;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 0 15px;
}

.title {
  font-size: 20px;
  margin: 0 0 8px;
  opacity: 0.8;
}

.main-title {
  font-size: 36px;
  margin: 0 0 16px;
  font-weight: bold;
}

.icon-item span {
  font-size: 12px;
  display: inline-block;
  max-width: 100%;
  opacity: 0.8;
}

/* 主内容区域样式 */
.main-container {
  width: 100%;
  max-width: 1165px;
  margin: 0 auto;
  padding: 120px 15px 45px;
  box-sizing: border-box;
}

/* 介绍区域通用样式 */
.introduce {
  color: #fff;
}

.introduce-title {
  height: auto;
  font-family: Noto Sans SC, Noto Sans SC;
  font-weight: 400;
  font-size: 36px;
  color: #FFFFFF;
  font-style: normal;
  text-transform: none;
  margin-bottom: 12px;
}

.introduce-prompt {
  width: 56px;
  height: 17px;
  font-family: Noto Sans SC, Noto Sans SC;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
  text-align: left;
  font-style: normal;
  text-transform: none;
  opacity: 0.7;
}

.introduce-content {
  width: 100%;
  height: auto;
  font-family: Noto Sans SC, Noto Sans SC;
  font-weight: 400;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 36px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  white-space: normal;
  opacity: 0.7;
}

.xiahuaxian {
  width: 71px;
  height: 6px;
  background: #006BFF;
  border-radius: 5px;
  margin-bottom: 16px;
}

/* 公司介绍区域 */
.intro-section {
  display: flex;
  justify-content: space-between;
  margin-bottom: 80px;
  flex-wrap: wrap;
}

.intro-content {
  flex: 1;
  min-width: 300px;
  margin-right: 30px;
}

.intro-image {
  flex: 0 0 453px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.main-image {
  width: 455px;
  height: auto;
}

/* 数据统计区域 */
.divider {
  width: 100%;
  height: 1px;
  background: #D9D9D9;
  border-radius: 0;
  opacity: 0.3;
}

.divider-content {
  height: 90px;
  color: #fff;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 10px;
  flex-wrap: wrap;
}

.divider-item {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 10px;
}

.divider-icon {
  margin-right: 12px;
/*  width: 28px;*/
  height: 28px;
}

.divider-shuju {
  height: 43px;
  font-family: Noto Sans SC, Noto Sans SC;
  font-weight: bold;
  font-size: 36px;
  color: #FFFFFF;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.divider-shuoming {
  height: 17px;
  font-family: Noto Sans SC, Noto Sans SC;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-left: 5px;
  opacity: 0.7;
}

.divider-shuoming-foot {
  padding-top: 21px;
}

/* 技术介绍区域 */
.tech-section {
  display: flex;
  justify-content: space-between;
  margin-top: 141px;
  flex-wrap: wrap;
}

.tech-image {
  flex: 0 0 450px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
}

.tech-content {
  flex: 1;
  min-width: 300px;
  margin-left: 30px;
}

.ability-content {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding: 0;
  align-items: flex-end;
  margin-top: 20px;
}

.ability-item {
  margin-right: 50px;
  margin-bottom: 15px;
}

/* 服务领域区域 */
.fields-section {
  color: #fff;
  margin-top: 130px;
  text-align: center;
}

.section-title {
  margin-bottom: 40px;
}

.section-subtitle {
  font-size: 14px;
  opacity: 0.7;
  color: #FFFFFF;
}

.fields-grid {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.field-item {
  flex: 0 0 calc(25% - 20px);
  min-width: 150px;
  margin-bottom: 30px;
}

.field-image {
  width: 270px;
  height: 200px;
  margin-bottom: 15px;
}

.field-name {
  font-size: 16px;
}

/* 服务与维修区域 */
.service-section {
  color: #fff;
  margin-top: 130px;
  text-align: center;
}

.map-container {
  width: 100%;
  overflow: hidden;
}

.map-image {
  max-width: 100%;
  height: auto;
}
/* 手机端响应式样式（适配宽度≤768px设备） */
@media (max-width: 768px) {
  /* 顶部宣传区域 */
  .banner-image {
    height: 250px; /* 缩短banner图高度，适配手机屏幕 */
  }
  .banner-content {
    max-width: 90%; /* 内容宽度占满屏幕，留少量边距 */
  }
  .title {
    font-size: 16px; /* 缩小标题字体 */
  }
  .main-title {
    font-size: 24px; /* 缩小主标题字体 */
    margin-bottom: 12px;
  }
  .icon-item span {
    font-size: 11px; /* 缩小描述文字 */
  }

  /* 主内容区域 */
  .main-container {
    padding: 60px 15px 30px; /* 减少上下内边距，适配手机垂直空间 */
  }

  /* 介绍区域通用样式 */
  .introduce-title {
    font-size: 28px; /* 缩小介绍标题字体 */
  }
  .introduce-content {
    font-size: 14px; /* 缩小内容字体 */
    line-height: 28px; /* 调整行高，提升可读性 */
    -webkit-line-clamp: 6; /* 增加可显示行数，避免内容截断过多 */
  }
  .xiahuaxian {
    width: 50px; /* 缩短下划线长度 */
    height: 4px; /* 减薄下划线 */
  }

  /* 公司介绍区域 */
  .intro-section {
    flex-direction: column; /* 改为垂直排列，图片在内容下方 */
    margin-bottom: 50px; /* 减少底部间距 */
  }
  .intro-content {
    margin-right: 0; /* 取消内容区右侧间距 */
    margin-bottom: 25px; /* 内容与图片之间增加间距 */
  }
  .intro-image {
    flex: 0 0 auto; /* 取消图片固定宽度 */
    width: 100%; /* 图片宽度占满屏幕 */
  }
  .main-image {
    width: 100%; /* 图片宽度自适应屏幕 */
    max-width: 350px; /* 限制图片最大宽度，避免过大 */
  }

  /* 数据统计区域 */
  .divider-content {
    height: auto; /* 取消固定高度，自适应内容 */
    flex-direction: column; /* 改为垂直排列数据项 */
    padding: 20px 0; /* 调整上下内边距 */
  }
  .divider-item {
    margin: 12px 0; /* 数据项上下间距，取消左右间距 */
  }
  .divider-shuju {
    font-size: 28px; /* 缩小数据字体 */
    height: 35px;
  }
  .divider-shuoming {
    font-size: 13px; /* 缩小说明文字 */
  }
  .divider-icon {
    height: 24px; /* 缩小图标尺寸 */
    margin-right: 8px; /* 减少图标与文字间距 */
  }

  /* 技术介绍区域 */
  .tech-section {
    flex-direction: column; /* 改为垂直排列，图片在内容上方 */
    margin-top: 80px; /* 减少顶部间距 */
  }
  .tech-image {
    flex: 0 0 auto; /* 取消图片固定宽度 */
    width: 100%; /* 图片宽度占满屏幕 */
    margin-bottom: 25px; /* 图片与内容之间增加间距 */
  }
  .tech-content {
    margin-left: 0; /* 取消内容区左侧间距 */
  }
  .ability-content {
    justify-content: space-around; /* 能力项均匀分布 */
    margin-top: 15px;
  }
  .ability-item {
    margin-right: 0; /* 取消能力项右侧间距 */
    margin-bottom: 12px; /* 增加能力项上下间距 */
    text-align: center; /* 能力项文字居中 */
  }

  /* 服务领域区域 */
  .fields-section {
    margin-top: 80px; /* 减少顶部间距 */
  }
  .fields-grid {
    justify-content: space-around; /* 服务项均匀分布 */
  }
  .field-item {
    flex: 0 0 calc(50% - 15px); /* 一行显示2个服务项 */
    margin-bottom: 25px;
  }
  .field-image {
    width: 100%; /* 服务项图片宽度自适应 */
    max-width: 150px; /* 限制图片最大宽度 */
    height: auto; /* 图片高度自适应 */
  }
  .field-name {
    font-size: 14px; /* 缩小服务项名称字体 */
  }

  /* 服务与维修区域 */
  .service-section {
    margin-top: 80px; /* 减少顶部间距 */
  }
}
</style>